import React, { useEffect } from "react";
import { ReactComponent as Cross } from "../../assets/images/svg/Cross.svg";
import { ReactComponent as Recall } from "../../assets/images/svg/ReCall.svg";

function Feedback01(props) {
  console.log("Feedback01  props", props.customer);

  console.log("Show Customer Number in Feedback PopUp  : ",props.showCustomerNo)

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            Customer Name
          </label>
          <input
            type="text"
            key={props.customer.id}
            id="Answer"
            defaultValue={props.customer.customer_name || ""}
            className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            readOnly
          />
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-medium text-gray-700">
            Number
          </label>
          <input
            type="text"
            key={props.customer.id}
            id="Answer"
            defaultValue={
              props.showCustomerNo
                ? "NA" // If customerNumPermission is true, set default value to empty string
                : props.customer.customer_phone_number || "" // Otherwise, set it to customer_phone_number if it exists
            }
            className="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2.5 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
            readOnly
          />
        </div>
      </div>

      {props.customer.customer_details &&
        Object.keys(props.customer.customer_details).map((keyName, index) => (
          <div key={keyName}>
            <label className="mb-1.5 block text-sm font-medium text-gray-700">
              {keyName}
            </label>
            <textarea
              id="message"
              name="message"
              key={index}
              rows="4"
              readOnly
              className="block w-full overflow-y-auto rounded-lg border border-gray-300 bg-gray-50 p-3 text-sm text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
              defaultValue={props.customer.customer_details[keyName] || ""}
            />
          </div>
        ))}

      <div className="flex justify-end border-t border-gray-100 pt-5">
        <button
          onClick={() => {
            props.setcurrfback(props.next);
          }}
          className="rounded-full px-6 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform active:scale-95"
          style={{
            backgroundImage:
              "linear-gradient(177.88deg, #AFD462 1.79%, #6BC698 49.97%, #0FB1E2 82.06%)",
          }}
        >
          Next
        </button>
      </div>
    </>
  );
}
export default Feedback01;
